module.exports = __webpack_public_path__ + "media/images/footer-logo-a4b2a9e75b79e7f408f4ec1efa398761.svg";